import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { ShareXHelper_ABI } from "./abi/ShareXHelper_ABI";

export class ShareXInfoDetail {
    public forCalc:bigint;
    public forClaim:bigint;
}
export class ShareXInfo {
    public share_:bigint;
    public totalShare_:bigint;
    public ethCalc_:bigint;
    public ethClaim_:bigint;
    public info_:ShareXInfoDetail[];
}

export class ShareXHelperContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, ShareXHelper_ABI.GetABI(), provider);
    }

    async getInfo(sharexAdr:string, owner:string, tokensAdrs:string[]): Promise<ShareXInfo>
    {
        const result = await this._call("getShareXInfo",sharexAdr, owner, tokensAdrs);
        if (!result) return;
        return result;
    }

    // async getSymbols(erc20Adrs:string[]): Promise<string[]>
    // {
    //     const result = await this._call("getSymbols",erc20Adrs);
    //     return result;
    // }   


    
    //     async getStrategy(strategyAdr:string): Promise<VXStrategyInfo>
    //     {
    //         let result = await this._call("getStrategy", strategyAdr);
    //         if (!result) return;
    
    
    //         result.scope_.rateUPLS = this._toDecimal(result.scope_.rateUPLS);
    //         result.scope_.uPLSInStake = this._toDecimal(result.scope_.uPLSInStake);
    //         result.scope_.PLSToSwap = this._toDecimal(result.scope_.PLSToSwap);
    //         result.scope_.lastSplitTimestamp = result.scope_.lastSplitTimestamp;
    
    //         result.scope_.swapMinPLSAmount = this._toDecimal(result.scope_.swapMinPLSAmount);
    //         result.scope_.swapMaxPLSAmount = this._toDecimal(result.scope_.swapMaxPLSAmount);
    
    //         result.scope_.sendPLSIndex = this._toDecimal(result.scope_.sendPLSIndex);
    //         result.scope_.bnsIndex = this._toDecimal(result.scope_.bnsIndex);
    //         return result;
    //     }
}